export class StorageService {
  static fromStorage = (
    key: string,
    fallback: unknown = undefined,
    storage = localStorage,
  ) => {
    try {
      const valueRaw = storage.getItem(key);
      return valueRaw ? JSON.parse(valueRaw) : fallback;
    } catch (e) {
      Errors.report(e, { key });
    }
  };

  static toStorage = (
    key: string,
    data: unknown = {},
    storage = localStorage,
  ) => {
    try {
      const serialized = JSON.stringify(data);
      storage.setItem(key, serialized);
    } catch (e) {
      Errors.report(e, { key: data });
    }
  };

  static localStorageSupported = () => {
    const test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  };

  static sessionStorageSupported = () => {
    const test = 'test';
    try {
      sessionStorage.setItem(test, test);
      sessionStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  };
}
